/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Link } from '@atoms';
import { Form } from '@organisms';
import { COL_WITH_EXTRA } from '@constants';
import ROUTES from '@constants/routes';

import CompetitionSelect from '../CompetitionSelect';

const CompetitionField = ({ initialCompetition, wrapperCol, onChange, queryVariables, disabled, ...props }) => {
  const [selectedCompetition, setSelectedCompetition] = React.useState(initialCompetition);

  const handleChange = (competition) => {
    // eslint-disable-next-line no-unused-expressions
    onChange?.(competition);
    setSelectedCompetition(competition);
  };

  return (
    <Form.ItemWithExtra
      wrapperCol={{ ...COL_WITH_EXTRA, ...wrapperCol }}
      extra={
        !!selectedCompetition && (
          <Link
            to={`/${ROUTES.COMPETITIONS}/${selectedCompetition.id}/appearance`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Competition setup
          </Link>
        )
      }
      {...props}
    >
      <CompetitionSelect onChange={handleChange} queryVariables={queryVariables} disabled={disabled} />
    </Form.ItemWithExtra>
  );
};

export default CompetitionField;
